"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const DropdownMenu_scss_1 = __importDefault(require("./DropdownMenu.scss"));
const DropdownMenu_1 = __importDefault(require("./DropdownMenu"));
function DropdownMenuItem({ item, closeMenu }) {
    const onClick = (e) => {
        var _a;
        (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, e);
        if (!item.items) {
            closeMenu();
        }
    };
    const getContent = () => {
        return (react_1.default.createElement("div", { className: DropdownMenu_scss_1.default.item, style: item.progress
                ? {
                    background: `linear-gradient(to right, #e15e3788 ${item.progress}%, transparent ${item.progress}%, transparent 100%)`,
                }
                : {}, "data-disabled": item.disabled },
            react_1.default.createElement("div", { className: `${DropdownMenu_scss_1.default.button} ${item.isLoading && DropdownMenu_scss_1.default.loading}`, role: "button", onClick: onClick },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("img", { src: item.icon, alt: item.title }),
                    item.title),
                item.items ? (react_1.default.createElement("img", { src: assets_1.svgSystemChevronRight, className: DropdownMenu_scss_1.default.chevron, alt: "chevron right" })) : (react_1.default.createElement("div", { style: { width: '24px' } })),
                item.isLoading ? react_1.default.createElement(UI_1.SpinnerLoader, null) : null)));
    };
    return item.items && !item.disabled ? (react_1.default.createElement(DropdownMenu_1.default, { items: item.items, closeParent: closeMenu, showOn: "hover" }, getContent())) : (getContent());
}
exports.default = DropdownMenuItem;
